<template>
    <div :class="computedClass()"/>
</template>

<script>
export default {
    name: "LibyanOrnament",

    props: {
        horizontal: {
            type: Boolean,
            default: false,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        computedClass() {
            let computedClass = "view-separator";
            if (this.horizontal) computedClass += " horizontal";
            if (this.vertical) computedClass += " vertical";
            return computedClass;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../assets/theme/mytheme/variables";
.view-separator {
    background-image: url("../assets/ornament-gold.png");
    width: 40px;
    min-height: calc(100vh - 40px - $top-bar-height);
    background-repeat: repeat-y;
    background-size: contain;
    &.horizontal {
        background-image: url("../assets/ornament-gold-h.png");
        height: 40px;
        width: 100%;
        background-repeat: repeat-x;
        min-height: 0;
    }
}
@media screen and (max-width: 1200px) {
    .view-separator {
        background-image: url("../assets/ornament-gold-h.png");
        height: 40px;
        width: 100%;
        background-repeat: repeat-x;
        background-size: contain;
        min-height: 0;
        &.vertical {
            background-image: url("../assets/ornament-gold.png");
            width: 40px;
            min-height: calc(100vh - 40px - $top-bar-height);
            background-repeat: repeat-y;
            background-size: contain;
            height: unset;
        }
    }
}
.arab-horses {
    .view-separator {
        background-image: url("../assets/ornament-terracotta.png");
        &.horizontal {
            background-image: url("../assets/ornament-terracotta-h.png");
        }
    }
    @media screen and (max-width: 1200px) {
        .view-separator {
            background-image: url("../assets/ornament-terracotta-h.png");
            &.vertical {
                background-image: url("../assets/ornament-terracotta.png");
            }
        }
    }
}
</style>
